"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.split");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.array.find-index");

require("core-js/modules/web.dom.iterable");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _moment = _interopRequireDefault(require("moment"));

var _milkRun = require("@/mixins/milk-run/milk-run");

var _vuedraggable = _interopRequireDefault(require("vuedraggable"));

var _elementUi = require("element-ui");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MRTruckSummaryComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MRTruckSummaryComponent, _Mixins);

  var _super = _createSuper(MRTruckSummaryComponent);

  function MRTruckSummaryComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MRTruckSummaryComponent);
    _this = _super.apply(this, arguments);
    _this.currentTruck = {};
    _this.currentDriver = null;
    _this.truckInPlan = {};
    _this.dragOptions = {
      group: 'masterpointId',
      ghostClass: 'ghost',
      animation: 300,
      filter: '.disabled',
      onMove: function onMove(e) {
        return !e.related.classList.contains('disabled');
      }
    };
    _this.latestStartTime = null;
    _this.searchFilter = 'shipmentReference';
    _this.searchText = '';
    _this.truckStartTime = null;
    _this.currentPlanId = null;
    _this.popperOptions = {
      boundariesElement: 'body',
      gpuAcceleration: false
    };
    _this.sectionTitleHeight = 0;
    _this.sectionUtilitiesHeight = 0;
    _this.sectionFunctionHeight = 0;
    _this.deletedOrderId = null;
    _this.targetTruck = null;
    _this.targetPlanId = null;
    _this.isShowTransferPlanModal = false;
    return _this;
  }

  (0, _createClass2.default)(MRTruckSummaryComponent, [{
    key: "onRoutesChanges",
    value: function onRoutesChanges(newVal) {
      this.truckInPlan = this.getTruckInPlan(this.$selectedTruck);

      if (newVal.length > 0 && this.truckInPlan) {
        this.latestStartTime = newVal[0]['startTime'];
      }
    }
  }, {
    key: "onSelectedTruckChanges",
    value: function onSelectedTruckChanges(newVal) {
      if (newVal) {
        this.targetTruck = null;
        this.searchText = '';
        this.currentTruck = this.helper.cloneDeep(this.currTruck);
        var driverId = this.currentTruck['drivers'].length > 0 ? this.currentTruck['drivers'][0]['id'] : null;

        if (this.routes.length === 0) {
          this.currentPlanId = null;
          this.currentDriver = driverId;
          this.$selectedDriver = this.currentDriver;
          return;
        }

        this.truckInPlan = this.getTruckInPlan(newVal);

        if (this.truckInPlan) {
          var driverIds = this.truckInPlan['driverId'];
          driverId = driverIds[driverIds.length - 1];
          this.updateCurrentPlanId();
          this.updateCurrentDriverId();
        }

        this.currentDriver = driverId;
        this.$selectedDriver = this.currentDriver;
        this.truckStartTime = this.routes[0] && this.routes[0]['startTime'] ? this.routes[0]['startTime'] : null;
      } else {
        this.currentTruck = {};
        this.currentDriver = null;
        this.currentPlanId = null;
        this.searchText = '';
      }
    }
  }, {
    key: "onTruckPlanIdsChanges",
    value: function onTruckPlanIdsChanges(newVal, oldVal) {
      // hacked for some reason old and new are the same
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.updateCurrentPlanId();
      }
    }
  }, {
    key: "onCurrentPlanIdChanges",
    value: function onCurrentPlanIdChanges(newVal) {
      if (this.sectionTitleHeight === 0 || this.sectionUtilitiesHeight === 0 || this.sectionFunctionHeight) {
        this.handleSectionHeight();
      } // hacked


      if (newVal === '0') {
        this.currentPlanId = null;
      }

      if (!this.helper.isUndefined(newVal)) {
        this.updateCurrentDriverId();
      }

      this.$emit('onCurrentPlanIdChanges', newVal);
    }
  }, {
    key: "onSelectedPlanIdChanges",
    value: function onSelectedPlanIdChanges(newVal) {
      if (!this.helper.isUndefined(newVal)) {
        this.currentPlanId = newVal;
      }

      this.$emit('onCurrentPlanIdChanges', newVal);
    }
  }, {
    key: "driversList",
    get: function get() {
      return this.helper.orderBy(this.$drivers, [function (driver) {
        return driver['UserName'].toLowerCase();
      }], ['asc']);
    }
  }, {
    key: "isDriverSelectionDisabled",
    get: function get() {
      var _this2 = this;

      if (this.routes.length === 0) {
        return false;
      }

      var selectedRoutes = this.routes.filter(function (route) {
        return route['planId'] === _this2.currentPlanId;
      });
      return selectedRoutes.length > 0 ? this.helper.some(selectedRoutes, function (item) {
        return item['status'] === 'completed';
      }) : false;
    }
  }, {
    key: "isAssignDriverDisabled",
    get: function get() {
      return this.routes.length === 0 || this.helper.isUndefined(this.$selectedDriver) || this.helper.isUndefined(this.currentPlanId);
    }
  }, {
    key: "isTransferLoadPlanEnabled",
    get: function get() {
      var _this3 = this;

      return !( // Empty Truck
      this.targetTruck && this.getTruckPlanIdsByTruckId(this.targetTruck).length === 0 && !this.isPlanIdBelongToDifferentUser(this.currentPlanId) && !this.helper.some(this.getRoutes(this.$selectedTruck).filter(function (r) {
        return r['planId'] === _this3.currentPlanId;
      }), function (route) {
        return route.status === 'assigned' || route.status === 'completed';
      }) || // Existing Truck
      this.targetTruck && this.getTruckPlanIdsByTruckId(this.targetTruck).length > 0 && this.targetPlanId === 'newPlanId' && this.getRoutes(this.targetTruck).length > 0 && !this.isPlanIdBelongToDifferentUser(this.currentPlanId) && !this.isPlanIdBelongToDifferentUser(this.targetPlanId, this.targetTruck) && !this.helper.some(this.getRoutes(this.$selectedTruck).filter(function (r) {
        return r['planId'] === _this3.currentPlanId;
      }), function (route) {
        return route.status === 'assigned' || route.status === 'completed';
      }) && !this.helper.some(this.getRoutes(this.targetTruck).filter(function (r) {
        return r['planId'] === _this3.targetPlanId;
      }), function (route) {
        return route.status === 'assigned' || route.status === 'completed';
      }));
    }
  }, {
    key: "listHeight",
    get: function get() {
      // return '100%';
      var height = this.truckSummaryHeight - 8 - this.sectionTitleHeight - this.sectionUtilitiesHeight - this.sectionFunctionHeight - (this.isPlanIdBelongToDifferentUser(this.currentPlanId) ? 29 : 0);
      return "".concat(height, "px");
    }
  }, {
    key: "containerHeight",
    get: function get() {
      return {
        height: "".concat(this.truckSummaryHeight, "px")
      };
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      window.removeEventListener('resize', this.handleSectionHeight);
    }
  }, {
    key: "created",
    value: function created() {
      window.addEventListener('resize', this.handleSectionHeight);
    }
  }, {
    key: "handleCurrentDriverChanges",
    value: function handleCurrentDriverChanges() {
      var _this4 = this;

      var isTrueAnyChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.routes.length > 0) {
        var bufferRoutes = this.helper.cloneDeep(this.routes);
        this.helper.forEach(bufferRoutes, function (item) {
          if (item.planId === _this4.currentPlanId) {
            item['driverId'] = _this4.currentDriver;
          }
        });
        this.routes = bufferRoutes;
        var plan = this.helper.cloneDeep(this.$plan);
        var truckIndex = this.helper.findIndex(plan['trucks'], function (truck) {
          return truck['truckId'] === _this4.$selectedTruck;
        });

        if (truckIndex !== -1) {
          this.$anyChanges = isTrueAnyChanges;
          plan['trucks'][truckIndex]['driverId'] = this.helper.uniq(bufferRoutes.map(function (route) {
            return route.driverId;
          }).filter(function (driverId) {
            return !_this4.helper.isUndefined(driverId);
          }));
          this.$setPlan({
            'plan': plan
          });
          var selectedRoutes = this.routes.filter(function (route) {
            return route['planId'] === _this4.currentPlanId;
          });

          if (this.helper.some(selectedRoutes, function (item) {
            return item['status'] === 'assigned';
          })) {
            this.$isAssignedDriverChanges = true;
          }

          if (this.$isPlanExists) {
            this.$isUnassignedDriverChanges = true;
          }
        }
      }

      this.$selectedDriver = this.currentDriver;
    }
  }, {
    key: "onRouteClick",
    value: function onRouteClick(index) {
      var buffer = this.helper.cloneDeep(this.routes);
      this.helper.forEach(buffer, function (item, idx) {
        item['isHighlighted'] = idx === index;
      });
      this.routes = buffer;
    }
  }, {
    key: "assignToDriver",
    value: function () {
      var _assignToDriver = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this5 = this;

        var plan, truckIndex, payload, carPlate, orderIds, orderShipRefs, assignDriverResponse, isAssignSuccessful, invalidOrders, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                plan = this.helper.cloneDeep(this.$plan);
                truckIndex = this.helper.findIndex(plan.trucks, function (truck) {
                  return truck['truckId'] === _this5.$selectedTruck;
                });

                if (!(truckIndex !== -1)) {
                  _context.next = 26;
                  break;
                }

                plan['trucks'][truckIndex]['routes'].forEach(function (route) {
                  if (route.planId === _this5.currentPlanId) {
                    route.status = 'assigned';
                  }
                });
                payload = [];
                carPlate = this.getCarPlateFromDriverId(this.currentDriver);
                orderIds = this.helper.uniq(this.helper.flatten(plan.trucks[truckIndex].routes.filter(function (route) {
                  return route.planId === _this5.currentPlanId;
                }).map(function (route) {
                  return route.orderId;
                })));
                orderShipRefs = this.getShipRefsFromOrderId(orderIds);

                if (this.helper.isUndefined(carPlate)) {
                  _context.next = 26;
                  break;
                }

                this.helper.forEach(orderShipRefs, function (order) {
                  payload.push({
                    shipref: order,
                    drivercode: carPlate,
                    truckrecid: plan.trucks[truckIndex].truckId
                  });
                });

                if (!payload.length) {
                  _context.next = 26;
                  break;
                }

                _context.next = 13;
                return this.assignDriver(payload);

              case 13:
                assignDriverResponse = _context.sent;
                isAssignSuccessful = assignDriverResponse['isSuccess'];
                invalidOrders = assignDriverResponse['invalidOrders'];
                message = {
                  title: this.$i18n.t('planning.messages.assignOrderSuccess'),
                  duration: 5000
                };

                if (!isAssignSuccessful) {
                  _context.next = 24;
                  break;
                }

                _elementUi.Notification.success(message);

                this.$isAssignedDriverChanges = false;
                _context.next = 22;
                return this.savePlan(plan, true);

              case 22:
                _context.next = 26;
                break;

              case 24:
                message['message'] = "".concat(this.$i18n.t('planning.messages.assigningFailedBecause'), " ").concat(invalidOrders, " ").concat(this.$i18n.t('planning.messages.cantBeAssigned'));

                _elementUi.Notification.error(message);

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function assignToDriver() {
        return _assignToDriver.apply(this, arguments);
      }

      return assignToDriver;
    }()
  }, {
    key: "printPlanId",
    value: function () {
      var _printPlanId = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this6 = this;

        var payload, res, status, message, url;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.currentPlanId) {
                  _context2.next = 16;
                  break;
                }

                payload = [{
                  planId: this.currentPlanId,
                  truckId: this.truckInPlan['truckId'],
                  driverId: this.truckInPlan['driverId'],
                  orderId: this.helper.uniq(this.helper.flatten(this.truckInPlan['routes'].filter(function (route) {
                    return route.planId === _this6.currentPlanId;
                  }).map(function (route) {
                    return route.orderId;
                  }))),
                  routes: this.truckInPlan['routes'].filter(function (route) {
                    return route.planId === _this6.currentPlanId;
                  })
                }];
                _context2.next = 4;
                return this.planAPI.printPlanId(payload);

              case 4:
                res = _context2.sent;
                status = this.helper.get(res, 'data.status', 300);
                message = {
                  title: this.$i18n.t('planning.messages.printPlanSuccess'),
                  duration: 5000
                };

                if (!(!res || res['failed'] || status === 'error' || status === 'error header')) {
                  _context2.next = 11;
                  break;
                }

                message['message'] = "".concat(this.$i18n.t('planning.messages.printPlanFailed'));

                _elementUi.Notification.error(message);

                return _context2.abrupt("return", false);

              case 11:
                url = this.helper.get(res, 'data.url', null);

                if (this.helper.isUndefined(url)) {
                  _context2.next = 16;
                  break;
                }

                _elementUi.Notification.success(message);

                window.open(url, '_blank');
                return _context2.abrupt("return", true);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function printPlanId() {
        return _printPlanId.apply(this, arguments);
      }

      return printPlanId;
    }()
  }, {
    key: "isRouteLate",
    value: function isRouteLate(route) {
      var orderId = parseInt(route.masterpointId.split('-')[0], 10) || null;
      var waypointIndex = parseInt(route.masterpointId.split('-')[1], 10) || null;
      var eta = route.estimateTime;

      if (orderId && waypointIndex) {
        var order = this.$plan['orders'].filter(function (o) {
          return o['id'] === orderId;
        });

        if (!order || order.length === 0) {
          return '';
        }

        var waypoint = order[0].waypoints[waypointIndex - 1];

        if (!waypoint || waypoint.length === 0) {
          return '';
        }

        var endTime = waypoint.endTime;

        if (endTime.substring(11, 19) === '00:00:00') {
          endTime = (0, _moment.default)(endTime).format('YYYY-MM-DD 23:59:59');
        }

        return (0, _moment.default)(eta).diff(endTime) > 0 ? 'route-late' : '';
      }

      return '';
    }
  }, {
    key: "getRouteStyles",
    value: function getRouteStyles(route) {
      var _this7 = this;

      var bool = false;
      var bool2 = route.planId === this.currentPlanId;
      var bool3 = this.truckPlanIds.length > 0 && this.helper.isUndefined(this.currentPlanId);

      if (this.helper.isNotEmpty(this.searchText)) {
        if (route && route[this.searchFilter]) {
          bool = typeof route[this.searchFilter] === 'string' ? route[this.searchFilter].toString().trim().toLowerCase().includes(this.searchText.trim().toLowerCase()) : route[this.searchFilter].find(function (item) {
            return item.toString().trim().toLowerCase().includes(_this7.searchText.trim().toLowerCase());
          });
        }
      } else {
        bool = true;
      }

      return {
        cursor: 'initial',
        display: bool && bool2 || bool3 ? 'block' : 'none'
      };
    }
  }, {
    key: "getTargetRouteStyles",
    value: function getTargetRouteStyles(route) {
      var bool2 = route.planId === this.targetPlanId;
      var bool3 = this.getTruckPlanIdsByTruckId(this.targetTruck).length > 0 && this.helper.isUndefined(this.targetPlanId);

      if (this.targetPlanId === 'newPlanId') {
        return {
          display: 'none'
        };
      }

      return {
        cursor: 'initial',
        display: bool2 || bool3 ? 'block' : 'none'
      };
    }
  }, {
    key: "getRouteClass",
    value: function getRouteClass(route) {
      var _this8 = this;

      var isRouteLast = false;
      var bufferRoutes = this.routes.filter(function (r) {
        return r['planId'] === _this8.currentPlanId;
      });

      if (bufferRoutes.length > 0) {
        isRouteLast = bufferRoutes[bufferRoutes.length - 1]['_id'] === route['_id'];
      }

      return {
        'last-child': isRouteLast,
        'disabled': route.locked || route.status === 'completed',
        'pick-up': route['waypointType'] === 'P',
        'drop-off': route['waypointType'] === 'D',
        'action': route['waypointType'] === 'T'
      };
    }
  }, {
    key: "getTargetRouteClass",
    value: function getTargetRouteClass(route) {
      var _this9 = this;

      var isRouteLast = false;
      var bufferRoutes = this.getRoutes(this.targetTruck).filter(function (r) {
        return r['planId'] === _this9.targetPlanId;
      });

      if (bufferRoutes.length > 0) {
        isRouteLast = bufferRoutes[bufferRoutes.length - 1]['_id'] === route['_id'];
      }

      return {
        'last-child': isRouteLast,
        'disabled': route.locked || route.status === 'completed',
        'pick-up': route['waypointType'] === 'P',
        'drop-off': route['waypointType'] === 'D',
        'action': route['waypointType'] === 'T'
      };
    }
  }, {
    key: "updateCurrentPlanId",
    value: function updateCurrentPlanId() {
      var _this10 = this;

      if (this.truckInPlan && this.truckInPlan['planId']) {
        var truckPlanIds = this.truckInPlan['planId'];
        var index = truckPlanIds.findIndex(function (planId) {
          return planId === _this10.selectedPlanId;
        });
        this.currentPlanId = index !== -1 ? this.selectedPlanId || null : truckPlanIds.length > 0 ? truckPlanIds[truckPlanIds.length - 1] : null;
        this.$emit('onCurrentPlanIdChanges', this.currentPlanId);
      }
    }
  }, {
    key: "updateCurrentDriverId",
    value: function updateCurrentDriverId() {
      var _this11 = this;

      var driverId = this.currentTruck['drivers'].length > 0 ? this.currentTruck['drivers'][0]['id'] : null;

      if (this.truckInPlan && this.truckInPlan['routes']) {
        var matchedRoute = this.truckInPlan['routes'].find(function (route) {
          return route.planId === _this11.currentPlanId;
        });

        if (!this.helper.isUndefined(matchedRoute) && !this.helper.isUndefined(matchedRoute['driverId'])) {
          driverId = matchedRoute['driverId'];
        }
      }

      if (this.helper.isUndefined(this.currentDriver)) {
        this.currentDriver = driverId;
        this.$selectedDriver = this.currentDriver;
      }
    }
  }, {
    key: "handleSectionHeight",
    value: function handleSectionHeight() {
      var _this12 = this;

      this.$nextTick(function () {
        _this12.sectionTitleHeight = _this12.helper.get(document.getElementById('sectionTitle'), 'offsetHeight', 0);
        _this12.sectionUtilitiesHeight = _this12.helper.get(document.getElementById('sectionUtilities'), 'offsetHeight', 0);
        _this12.sectionFunctionHeight = _this12.helper.get(document.getElementById('sectionFunction'), 'offsetHeight', 0);
      });
    }
  }, {
    key: "getUsername",
    value: function getUsername() {
      var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.routes;
      var planId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.currentPlanId;
      return this.helper.get(routes.filter(function (r) {
        return r['planId'] === planId;
      }), '0.createdUser', this.$userInformation.user.name);
    }
  }, {
    key: "getOrderId",
    value: function getOrderId(route) {
      return parseInt(route.masterpointId.split('-')[0], 10) || null;
    }
  }, {
    key: "isRouteVisible",
    value: function isRouteVisible(route) {
      var planId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.currentPlanId;
      var startDate = (0, _moment.default)(route.startTime);
      var endDate = (0, _moment.default)(route.endTime);
      var start = (0, _moment.default)(this.$planDateRange[0]);
      var end = (0, _moment.default)(this.$planDateRange[1]);
      return route.planId === planId && (startDate.isBetween(start, end, 'days', '[]') || endDate.isBetween(start, end, 'days', '[]') || start.isBetween(startDate, endDate, 'days', '[]') || end.isBetween(startDate, endDate, 'days', '[]'));
    }
  }, {
    key: "getAddressStyle",
    value: function getAddressStyle(route) {
      return route['new'] || route['status'] === 'assigned' ? {
        width: 'calc(100% - 60px)'
      } : {
        width: 'calc(100% - 45px)'
      };
    }
  }, {
    key: "deleteRoute",
    value: function () {
      var _deleteRoute = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(route) {
        var _this13 = this;

        var truckIndex;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Assume orderId always has length of 1
                this.deletedOrderId = route.orderId[0];
                truckIndex = this.helper.findIndex(this.$plan.trucks, function (truck) {
                  return truck['truckId'] === _this13.$selectedTruck;
                });
                _context3.next = 4;
                return route.new;

              case 4:
                if (!_context3.sent) {
                  _context3.next = 8;
                  break;
                }

                this.deleteUnsavedRoute(route, truckIndex);
                _context3.next = 9;
                break;

              case 8:
                this.confirmDelete(route, truckIndex);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deleteRoute(_x) {
        return _deleteRoute.apply(this, arguments);
      }

      return deleteRoute;
    }()
  }, {
    key: "deleteUnsavedRoute",
    value: function () {
      var _deleteUnsavedRoute = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(route, truckIndex) {
        var bufferPlan;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // Assume orderId always has length of 1
                bufferPlan = this.helper.cloneDeep(this.$plan);
                bufferPlan.trucks[truckIndex].routes = this.currPlanTruck['routes'].filter(function (r) {
                  return r.orderId[0] !== route.orderId[0];
                });
                bufferPlan.trucks[truckIndex].orderId = this.currPlanTruck['orderId'].filter(function (oId) {
                  return oId !== route.orderId[0];
                });
                bufferPlan.trucks[truckIndex].shipmentReference = this.currPlanTruck['shipmentReference'].filter(function (sId) {
                  return sId !== route.shipmentReference[0];
                });
                bufferPlan.trucks[truckIndex].planId = this.currPlanTruck['planId'].filter(function (pId) {
                  return pId !== route.planId;
                });
                this.$setPlan({
                  'plan': bufferPlan
                });
                this.currentPlanId = null;
                _context4.next = 9;
                return this.refreshOrderTable();

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function deleteUnsavedRoute(_x2, _x3) {
        return _deleteUnsavedRoute.apply(this, arguments);
      }

      return deleteUnsavedRoute;
    }()
  }, {
    key: "deleteSavedRoute",
    value: function () {
      var _deleteSavedRoute = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(route, truckIndex) {
        var _this14 = this;

        var payload;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // Assume orderId always has length of 1
                payload = {
                  routes: this.currPlanTruck['routes'].filter(function (r) {
                    return r.orderId[0] === _this14.deletedOrderId;
                  }),
                  orderId: this.deletedOrderId
                };
                _context5.next = 3;
                return this.deleteRoutesOrderId(payload);

              case 3:
                _context5.next = 5;
                return this.refreshOrderTable();

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deleteSavedRoute(_x4, _x5) {
        return _deleteSavedRoute.apply(this, arguments);
      }

      return deleteSavedRoute;
    }()
  }, {
    key: "refreshOrderTable",
    value: function () {
      var _refreshOrderTable = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this15 = this;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.$excludedOrders = this.$excludedOrders.filter(function (orderId) {
                  return orderId !== _this15.deletedOrderId;
                });
                this.$includedOrders = [].concat((0, _toConsumableArray2.default)(this.$includedOrders), [this.deletedOrderId]);
                _context6.next = 4;
                return this.$getUnassignedOrders();

              case 4:
                this.deletedOrderId = null;

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function refreshOrderTable() {
        return _refreshOrderTable.apply(this, arguments);
      }

      return refreshOrderTable;
    }()
  }, {
    key: "confirmDelete",
    value: function () {
      var _confirmDelete = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(route, truckIndex) {
        var _this16 = this;

        var message;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                message = this.$i18n.t('planning.messages.partiallyDeleteRoutesTruckConfirmation');

                _elementUi.MessageBox.confirm(message, 'Warning', {
                  confirmButtonText: this.$i18n.t('pickColumns.confirm'),
                  cancelButtonText: this.$i18n.t('pickColumns.cancel'),
                  type: 'warning',
                  center: true
                }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                  return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          _context7.next = 2;
                          return _this16.deleteSavedRoute(route, truckIndex);

                        case 2:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee7);
                }))).catch(function (action) {});

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function confirmDelete(_x6, _x7) {
        return _confirmDelete.apply(this, arguments);
      }

      return confirmDelete;
    }()
  }, {
    key: "handleLoadPlanModalClose",
    value: function handleLoadPlanModalClose() {
      this.targetTruck = null;
      this.targetPlanId = null;
    }
  }, {
    key: "handleSearchShipRef",
    value: function handleSearchShipRef(val) {
      var _this17 = this;

      var route = this.routes.find(function (r) {
        return typeof r[_this17.searchFilter] === 'string' ? r[_this17.searchFilter].toString().trim().toLowerCase().includes(val.trim().toLowerCase()) : r[_this17.searchFilter].find(function (item) {
          return item.toString().trim().toLowerCase().includes(val.trim().toLowerCase());
        });
      });

      if (!this.helper.isUndefined(route) && route['planId'] !== this.currentPlanId) {
        this.currentPlanId = route['planId'];
      }
    }
  }]);
  return MRTruckSummaryComponent;
}((0, _vuePropertyDecorator.Mixins)(_milkRun.MilkRunMixin));

(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: 'manual'
})], MRTruckSummaryComponent.prototype, "type", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 1191
})], MRTruckSummaryComponent.prototype, "truckSummaryHeight", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: null
})], MRTruckSummaryComponent.prototype, "selectedPlanId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('routes', {
  deep: true
})], MRTruckSummaryComponent.prototype, "onRoutesChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$selectedTruck')], MRTruckSummaryComponent.prototype, "onSelectedTruckChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('truckPlanIds')], MRTruckSummaryComponent.prototype, "onTruckPlanIdsChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('currentPlanId')], MRTruckSummaryComponent.prototype, "onCurrentPlanIdChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('selectedPlanId')], MRTruckSummaryComponent.prototype, "onSelectedPlanIdChanges", null);
MRTruckSummaryComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'MRTruckSummaryComponent',
  components: {
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-button': _elementUi.Button,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-switch': _elementUi.Switch,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'draggable': _vuedraggable.default,
    'el-tooltip': _elementUi.Tooltip,
    'el-input': _elementUi.Input,
    'el-tabs': _elementUi.Tabs,
    'el-tab-pane': _elementUi.TabPane,
    'el-dialog': _elementUi.Dialog
  }
})], MRTruckSummaryComponent);
var _default = MRTruckSummaryComponent;
exports.default = _default;